import PropTypes from 'prop-types'
import Input from '../../ui/Input'
import GenericSelect from '../genericSelect/GenericSelect'
import styles from './GenericModal.module.css'

export const GenericInputs = ({
  content = {},
  value = '',
  onChange,
  errores = {},
  editMode,
  filaIndex = -1
}) => {
  const { type, name, label, placeholder, options, isFullWidth, isEditable, ...inputProps } =
    content

  const obtenerValorFinal = (valorIngresado) => {
    if (type !== 'number') {
      return valorIngresado
    }

    if (valorIngresado === '' || valorIngresado === null || valorIngresado === undefined) {
      return ''
    }

    const maxConfigurado =
      inputProps.max !== undefined && inputProps.max !== null ? Number(inputProps.max) : null

    if (maxConfigurado === null || Number.isNaN(maxConfigurado)) {
      return valorIngresado
    }

    const valorNumerico = Number(valorIngresado)
    if (Number.isNaN(valorNumerico)) {
      return valorIngresado
    }

    return valorNumerico > maxConfigurado ? String(value ?? '') : valorIngresado
  }

  const inputName = filaIndex === -1 ? name : `${name}_${filaIndex}`

  return (
    <div className={styles.lista}>
      <div
        key={name}
        className={`${styles.inputs} ${isFullWidth ? styles.fullWidth : styles.partialWidthInputs}`}
      >
        {filaIndex === -1 && <label htmlFor={name}>{label}</label>}
        {type === 'select' ? (
          <GenericSelect
            options={(options || []).map((option) => ({
              value: option.value,
              label: option.label,
              key: option.key
            }))}
            errores={errores}
            id={inputName}
            name={inputName}
            disabled={editMode && !isEditable}
            value={value}
            placeholder={placeholder}
            onChange={(val) => {
              if (filaIndex !== -1) {
                onChange({
                  target: { name, value: val, filaIndex }
                })
              } else {
                onChange({ target: { name, value: val } })
              }
            }}
            {...inputProps}
          />
        ) : (
          <Input
            type={type}
            name={inputName}
            value={value}
            onChange={(val) => {
              const valorFinal = obtenerValorFinal(val.target.value)

              if (filaIndex !== -1) {
                onChange({
                  target: { name, value: valorFinal, filaIndex }
                })
              } else {
                onChange({ target: { name, value: valorFinal } })
              }
            }}
            placeholder={placeholder || ''}
            className="input-text-bordered"
            label={label}
            errores={errores}
            disabled={editMode && !isEditable}
            {...inputProps}
          />
        )}
      </div>
    </div>
  )
}

GenericInputs.propTypes = {
  content: PropTypes.shape({
    type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password', 'select']),
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    isFullWidth: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string.isRequired,
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    )
  }),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  errores: PropTypes.object,
  editMode: PropTypes.bool,
  filaIndex: PropTypes.number
}
